import moment from 'moment';

import { INTERNAL_DATE_FORMAT } from '../../utils/constants';

export default function campaignDatesChanged(
  initialCampaignLines,
  campaignLinesById,
) {
  let dateChanged = false;

  for (let i = 0; i < initialCampaignLines.length; i += 1) {
    const { startDate } = initialCampaignLines[i];
    const initialStartDate = moment(startDate, INTERNAL_DATE_FORMAT);

    const changedStartDate = moment(
      campaignLinesById[initialCampaignLines[i].id].startDate,
      INTERNAL_DATE_FORMAT,
    );

    if (changedStartDate.isAfter(initialStartDate)) {
      dateChanged = true;
      break;
    }
  }

  return dateChanged;
}
